// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__Dx0qR","popup":"Popup_popup__oxzoZ","footerButtons":"Popup_footerButtons__L7Cpw"};